/**
 * Created by weijianli on 16/9/27.
 */
import getQueryString from '../helper/getQueryString'

function setupWebViewJavascriptBridge(callback) {
  if (window.WebViewJavascriptBridge) {
    return callback(WebViewJavascriptBridge);
  }
  if (window.WVJBCallbacks) {
    return window.WVJBCallbacks.push(callback);
  }
  window.WVJBCallbacks = [callback];

  if (window.cardloan) {
    window.cardloan.loadBridge();
  } else {
    let WVJBIframe = document.createElement('iframe');
    WVJBIframe.style.display = 'none';
    WVJBIframe.src = 'wvjbscheme://__BRIDGE_LOADED__';
    document.documentElement.appendChild(WVJBIframe);
    setTimeout(function() {
      document.documentElement.removeChild(WVJBIframe);
    }, 0);
  }
}

export default new Promise(function(resolve, reject) {

    if (window.callBridge) {
      resolve();
    } else {
      setupWebViewJavascriptBridge(function(bridge) {
        window.callBridge = function(handler, params, cb) {
          bridge.callHandler(handler, params, cb);
        };
        window.registerHandler = function(handler, cb) {
          bridge.registerHandler(handler, cb);
        };
        resolve();
      });
    }
    if(getQueryString('debug')){
      resolve()
    }
});
